module.exports = __webpack_public_path__ + "static/media/face-female-2.ea1ac579.jpg";